import Content from '../types/enums/content';
import { FunctionComponent } from 'react';

export type SettingIcon = FunctionComponent<{
  width?: number;
  height?: number;
  margin?: string;
}>;

interface Params {
  Icon: SettingIcon;
  title: string;
  action: (node?: number | null) => void;
}

class Setting {
  Icon: SettingIcon;
  title: string;
  type: Content;
  action: (node?: number | null) => void;

  constructor({ action, Icon, title }: Params) {
    this.Icon = Icon;
    this.title = title;
    this.type = Content.SETTING;
    this.action = action;
  }
}

export default Setting;
